import { useState, useEffect, useCallback } from 'react';
// import CustomerReportsService from '@/services/CustomerReportsService';
import ReportsService from '@/services/reportsService';
import { toast } from 'react-hot-toast';

const EMPTY_SUMMARY = {
  newCustomers: 0,
  repeatCustomers: 0,
  newRevenue: 0,
  repeatRevenue: 0,
};

const useCustomerRetentionReport = (initialFilters = {}) => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(EMPTY_SUMMARY);
  const [branchSummary, setBranchSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    period: initialFilters.period,
    startDate: initialFilters.startDate,
    endDate: initialFilters.endDate,
    branchId: initialFilters.branchId,
    offset: initialFilters.offset ?? 0,
    limit: initialFilters.limit ?? 25,
  });

  const fetchReport = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

    
      const payload =
        await ReportsService.getCustomerRetentionDaily(filters);

      if (!payload) throw new Error('Empty API response');

     
      setSummary(payload.summary ?? EMPTY_SUMMARY);
      setBranchSummary(payload?.branchSummary ?? []);

      const rows = Array.isArray(payload?.table?.content)
        ? payload.table.content.map((row, idx) => ({
            id: idx + 1,
            date: row.date,
            newCustomers: Number(row.new ?? 0),
            newRevenue: Number(row.newRevenue ?? 0),
            repeatCustomers: Number(row.repeat ?? 0),
            repeatRevenue: Number(row.repeatRevenue ?? 0),
            totalCustomers: Number(row.total ?? 0),
            repeatRate: Number(row.repeatPercent ?? 0),
          }))
        : [];

      setData(rows);
    } catch (err) {
      console.error(err);
      setError('Failed to load New vs Repeat report');
      toast.error('Failed to load New vs Repeat report');
      setData([]);
      setSummary(EMPTY_SUMMARY);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  return {
    data,
    summary,
    branchSummary,
    loading,
    error,
    setFilters,
    refreshCustomerRetention: fetchReport,
  };
};

export default useCustomerRetentionReport;
